/* eslint-disable no-magic-numbers */

import Nothing from './phase-core/Nothing';
import Start from './phase-core/Start';
import Stop from './phase-core/Stop';

import NoiseInit from './phase-video/NoiseInit';
import NoiseSine from './phase-video/NoiseSine';
import NoiseBeat from './phase-video/NoiseBeat';

import Flash from './phase-video/Flash';

import FrameInit from './phase-video/FrameInit';
import Boom from './phase-video/Boom';
import Grow from './phase-video/Grow';
import SetBaseSize from './phase-video/SetBaseSize';
import Energise from './phase-video/Energise';
import Spin from './phase-video/Spin';

import HeadEnter from './phase-video/HeadEnter';
import HeadFloat from './phase-video/HeadFloat';
import HeadPingPong from './phase-video/HeadPingPong';
import HeadTurn from './phase-video/HeadTurn';
import HeadTurnCircle from './phase-video/HeadTurnCircle';
import HeadGrow from './phase-video/HeadGrow';

import PusherEnter from './phase-video/PusherEnter';

import ImageConfig from './phase-video/ImageConfig';

/* Define the timeline of changes to state of video generator objects */

export default [

	/* Brainwaves */

	[new Nothing(8)],

	[new Start('noise')],

	[new NoiseInit()],

	[new NoiseSine(8).add(1, 1 / 14)],
	[new NoiseSine(4).add(1, 1 / 14)
		.add(
			({ passageClamped }) => passageClamped * 16,
			({ passageClamped }) => passageClamped / 10)],

	[new NoiseSine(4).add(1, 1 / 14).add(16, 1 / 10)],

	[new Start('flash')],

	[new Flash()],

	[new NoiseBeat(8)],
	[new NoiseBeat(8).mirror()],

	[new Stop('noise')],

	/* Triangle */

	[new Start('frame')],

	[new FrameInit()],

	[new Grow(8, 3)],
	[new Boom()],

	[new SetBaseSize(24)],

	[new Energise(8)],
	[new Boom()],

	[new Spin(16)],
	[new Boom()],


	[new Stop('flash')],

	/* Head */

	[
		new SetBaseSize(48),
		new Start('pusher', 1),
		new ImageConfig('pusher', 'overlay'),
		new Start('headshot', 1),
		new ImageConfig('headshot', 'overlay'),
		new HeadGrow(0, 0.5, 0.5),
	],
	[
		new HeadEnter(4),
		new PusherEnter(4),
		new Spin(4)
	],
	[
		new HeadFloat(4),
		new PusherEnter(4, [[0], [3], [1], [0,1,2,3]], [Math.PI / 4, Math.PI / 4]),
		new Spin(4)
	],
	[
		new HeadPingPong(4),
		new PusherEnter(4, [[0], [1], [2], [3]], [-Math.PI / 12, 0]),
		new Spin(4)
	],

	[
		new HeadTurn(3),
		new PusherEnter(4, [[0], [3], [0], [0,3]], [Math.PI / 4, Math.PI / 4]),
		new Energise(4),
	],

	[
		new Stop('frame'),
		new Stop('pusher'),
		new ImageConfig('headshot', 'underlay'),
		new Start('flash'),
	],

	[
		new HeadTurnCircle(8),
	],

	[
		new Stop('flash'),
	],

	[
		new HeadTurnCircle(8),
		new HeadGrow(8, 0.5, 60),
	],

	[
		new Start('frame'),
		new SetBaseSize(0),
		new Start('flash'),
	],
	[
		new HeadTurnCircle(4),
		new Grow(4, 20),
	],
	[
		new SetBaseSize(100),
		new Stop('flash'),
	],
	[
		new HeadTurnCircle(4),
		new Energise(4),
	],

	[
		new Stop('frame'),
		new Stop('headshot'),
		new Stop('flash'),
	],

	[new Nothing(8)],

];
